<template>
	<div class="wrapper page-container scroll-view" style="overflow: auto">
		<!--    <div class="nav_warp">
      <div
        class="nav_item"
        :class="index == 0 ? 'nav_item_ac' : ''"
        @click="navClick(0)"
      >
        <span>承运单</span>
        <div v-if="index == 0" class="nav_item_line"></div>
      </div>
      <div
        class="nav_item"
        :class="index == 1 ? 'nav_item_ac' : ''"
        @click="navClick(1)"
      >
        <span>托运单</span>
        <div v-if="index == 1" class="nav_item_line"></div>
      </div>
    </div> -->

		<div class="custUpWarp" v-show="index == 0">
			<div class="todayData">
				<div class="todayTit">运营概况</div>
				<div class="dataWarp">
					<div class="data_item" v-for="(item, index) in todayArr" :key="index">
						<div>{{ item.tit }}</div>
						<div>{{ item.val }}</div>
					</div>
				</div>
			</div>

			<div class="data_cart_warp">
				<!-- <div class="dataTit">数据趋势</div> -->
				<div class="bottom_chart_tit">
					<div class="dataTit">数据趋势</div>
					<div class="choose_btn_box">
						<div class="flex flex-y-center custTjItemRight">
							<p :class="[ddtjType == '1' ? 'ac' : '']" @click="changeItem('1')">
								承运单量
							</p>
							<p :class="[ddtjType == '2' ? 'ac' : '']" @click="changeItem('2')">
								承运收入
							</p>
						</div>

						<div class="choose_type" style="border-radius: 4px 0px 0px 4px"
							:class="type == 'month' ? 'choose_type_ac' : ''" @click="changeType('month')">
							月
						</div>
						<div class="choose_type" @click="changeType('year')"
							:class="type == 'year' ? 'choose_type_ac' : ''" style="border-radius: 0px 4px 4px 0px">
							年
						</div>
						<div class="month_input" v-if="type == 'month'" style="width: 150px">
							<el-date-picker v-model="monthStr" type="month" placeholder="选择月" :clearable="false"
								@change="getMonth">
							</el-date-picker>
						</div>
						<div class="month_input" v-if="type == 'year'">
							<el-date-picker v-model="year" type="year" placeholder="选择年" :clearable="false"
								@change="getYear">
							</el-date-picker>
						</div>
					</div>
				</div>
				<div class="bottom_chart">
					<div style="width: 100%; height: 200px" ref="chartRef"></div>
				</div>

				<!-- <div class="data_search_warp">


				</div>
				<div class="chart_box1">
					<div id="myUserChart1"></div>
				</div> -->
			</div>

		</div>
		<div v-show="index==1" style="width: 100%;">
			<custTj></custTj>
		</div>
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";

	export default defineComponent({
		components: {},
		name: "adminIndex",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const chartRef = ref(null);

			const data = reactive({
				index: 0,
				todayArr: [{
						tit: "总车辆数",
						val: 0,
					},
					{
						tit: "当日营运车辆数",
						val: 0,
					},
					{
						tit: "当日派单数",
						val: 0,
					},
					{
						tit: "当日承运收入",
						val: 0,
					},
					{
						tit: "当月承运单量",
						val: 0,
					},
					{
						tit: "当月承运收入",
						val: 0,
					},
					{
						tit: "在途吨位",
						val: 0,
					},
					{
						tit: "在途单数",
						val: 0,
					},
					{
						tit: "证件到期",
						val: 0,
					},
					{
						tit: "保养提醒",
						val: 0,
					},
					{
						tit: "项目检测到期",
						val: 0,
					},
					{
						tit: "报废到期",
						val: 0,
					},
				],
				titArr: [{
						tit: "承运单量",
						type: "newUserCount",
					},
					{
						tit: "承运收入",
						type: "pubNewUserCount",
					},
				],
				titType: "newUserCount",
				titIndex: 0,
				classfyArr: [{
					tit: "全部",
					type: 0,
				}, ],
				classfyIndex: 0,
				dayArr: [],
				myUserChart1: null,
				myUserChart2: null,
				allData: [],
				userType: {},
				ddtjType: "1",
				monthStr: "",
				type: "month",
				year: "",
				month: "",
				myChart4: null,

				permissionItem: {
					see: false,
				},
			});

			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "homePage:see") {
						data.permissionItem.see = true;
					}
				});

				nextTick(() => {
					getData();

					var d = new Date();
					var year = d.getFullYear();
					var month = d.getMonth() + 1;
					if (month < 10) {
						month = "0" + month;
					}
					data.year = year.toString();
					console.log(data.year);
					data.monthStr = year + "-" + month;
					data.month = month;

					console.log('chartRef', proxy.$refs.chartRef)
					data.myChart4 = proxy.$echarts.init(proxy.$refs.chartRef);
					getList();
				});
			});

			const changeType = (type) => {
				data.type = type;
				getList();
			};

			const changeItem = (val) => {
				data.ddtjType = val;

				if (!data.permissionItem.see) {
					return;
				}

				let xData = [];
				let yData = [];

				if (data.ddtjType == 1) {
					//1单量
					data.allData.countList.forEach((item, index) => {
						if (data.type == "year") {
							xData.push(index + 1 + "月");
						}
						if (data.type == "month") {
							xData.push(index + 1 + "日");
						}
						yData.push(item);
					});

				} else {
					//2收入
					data.allData.moneyList.forEach((item, index) => {
						if (data.type == "year") {
							xData.push(index + 1 + "月");
						}
						if (data.type == "month") {
							xData.push(index + 1 + "日");
						}
						yData.push(Math.round(item));
					});
				}
				initMyChart4(xData, yData);
			};

			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.see) {
					return;
				}

				let params = {};
				const r = await proxy.$http.get(apiObj.homeStatistics, params);
				console.log(r);
				if (r.code === 0 || r.respCode == "0000") {
					initTodayArr(r);
				}
			};

			const initTodayArr = (today) => {
				data.todayArr.forEach((item) => {
					if (item.tit == "总车辆数") {
						item.val = today.regiVehCount;
					}
					if (item.tit == "当日营运车辆数") {
						item.val = today.todayWorkVehCount;
					}
					if (item.tit == "当日派单数") {
						item.val = today.todayAppoVehCount;
					}
					if (item.tit == "当日承运收入") {
						item.val = Math.round(today.todayOdrFreight).toLocaleString();
					}
					if (item.tit == "当月承运单量") {
						item.val = today.monthOdrCount;
					}
					if (item.tit == "当月承运收入") {
						item.val = Math.round(today.monthOdrFreight).toLocaleString();
					}
					if (item.tit == "在途吨位") {
						item.val = today.travelWeight;
					}
					if (item.tit == "在途单数") {
						item.val = today.travelOdrCount;
					}
				});
			};

			const getMonth = (ev) => {
				console.log(ev);
				var date = new Date(ev);
				var y = date.getFullYear();
				var month = date.getMonth() + 1;
				if (month < 10) {
					month = "0" + month;
				}
				data.monthStr = y + "-" + month;
				data.month = month;
				getList();
			};

			const getYear = (ev) => {
				var date = new Date(ev);
				var y = date.getFullYear();
				this.year = y.toString();
				getList();
			};

			//柱状图
			const getList = async () => {
				if (!data.permissionItem.see) {
					return;
				}

				let params = {
					type: data.type,
					year: data.year,
					month: data.month,
				};
				const r = await proxy.$http.postFormData(apiObj.homeorderCount, params);
				console.log(r);
				if (r.code === 0 || r.respCode == "0000") {
					data.allData = r;
					let xData = [];
					let yData = [];

					if (data.ddtjType == 1) {
						//1单量
						data.allData.countList.forEach((item, index) => {
							if (data.type == "year") {
								xData.push(index + 1 + "月");
							}
							if (data.type == "month") {
								xData.push(index + 1 + "日");
							}
							yData.push(item);
						});

					} else {
						//2收入
						data.allData.moneyList.forEach((item, index) => {
							if (data.type == "year") {
								xData.push(index + 1 + "月");
							}
							if (data.type == "month") {
								xData.push(index + 1 + "日");
							}
							yData.push(Math.round(item));
						});
					}
					initMyChart4(xData, yData);
				}
			};

			const initMyChart4 = (xData, yData) => {
				console.log(yData);
				var type = data.ddtjType == "1" ? "单" : "元";
				var option = {
					tooltip: {
						trigger: "axis",
						axisPointer: {
							type: "cross",
							label: {
								backgroundColor: "#FF7200",
							},
						},
					},
					xAxis: {
						type: "category",
						show: true,
						data: xData,
					},
					grid: {
						top: "10%",
						left: "5%",
						right: "5%",
						bottom: "10%",
						containLabel: false,
					},
					yAxis: {
						type: "value",
						show: true,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value} " + type,
						},
					},
					series: [{
						data: yData,
						type: "bar",
						smooth: true,
						barWidth: 15,
						itemStyle: {
							barBorderRadius: [50, 50, 0, 0],
							opacity: 0.8,
							color: new proxy.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: "#e36a19",
								},
								{
									offset: 1,
									color: "#ffffff",
								},
							]),
						},
						label: {
							show: true,
							position: "top",
							formatter: function(params) {
								if (Number(params.value) > 0) {
									return params.value + type;
								}
							},
						},
					}, ],
				};

				data.myChart4.setOption(option, true);
			};


			return {
				...toRefs(data),
				getData,
				getMonth,
				getYear,
				changeType,
				changeItem,
				chartRef,
			};
		},
	});
</script>

<style scoped>
	.nav_warp {
		width: 100%;
		height: 78px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 78px;
		padding: 0 20px;
		margin-left: 50px;
		cursor: pointer;
	}

	.nav_item span {
		font-size: 20px;
		color: #666666;
		line-height: 78px;
	}

	.nav_item_ac span {
		color: #26ca67 !important;
	}

	.nav_item_line {
		position: absolute;
		width: 90%;
		left: 5%;
		height: 3px;
		background: #2eb779;
		bottom: 5px;
	}

	.todayData {
		width: 100%;
		height: 265px;
		background: #ffffff;
	}

	.todayTit {
		width: 100%;
		height: 110px;
		line-height: 110px;
		font-size: 18px;
		color: #222222;
		text-indent: 50px;
		text-align: left;
	}

	.dataWarp {
		width: 100%;
		display: flex;
		height: 102px;
		display: flex;
	}

	.data_item {
		width: 12.5%;
		height: 102px;
		border-right: 1px solid #e5e5e5;
		color: #222222;
		text-align: center;
	}

	.dataWarp>div:nth-last-child() {
		border: none;
	}

	.data_item div:nth-of-type(1) {
		font-size: 16px;
	}

	.data_item div:nth-of-type(2) {
		font-size: 20px;
		font-weight: bold;
		margin-top: 20px;
	}

	.data_cart_warp {
		width: 100%;
		background: #ffffff;
		margin-top: 10px;
		padding-top: 25px;
	}

	.dataTit {
		width: 100%;
		text-align: left;
		font-size: 20px;
		text-indent: 50px;
		color: #222222;
	}

	.data_btn_warp {
		width: calc(100% - 55px);
		margin-top: 35px;
		margin-left: 55px;
		display: flex;
		padding-bottom: 34px;
		border-bottom: 1px solid #eeeeee;
	}

	.data_btn_warp div {
		padding: 0 20px;
		height: 36px;
		background: #ebebeb;
		border-radius: 7px;
		line-height: 36px;
		font-size: 14px;
		color: #666666;
		cursor: pointer;
		margin-right: 25px;
	}

	.data_btn_warp>.data_btn_ac {
		color: #ffffff;
		background: #26ca67;
	}

	.data_search_warp {
		width: calc(100% - 55px);
		margin-top: 35px;
		margin-left: 55px;
		display: flex;
	}

	.classfy_warp {
		display: flex;
		margin-left: 35px;
	}

	.classfy_warp div {
		width: 90px;
		height: 42px;
		border: 1px solid #e5e5e5;
		border-radius: 21px;
		font-size: 13px;
		color: #999999;
		text-align: center;
		line-height: 42px;
		margin-right: 20px;
		cursor: pointer;
	}

	.classfy_warp .classfy_ac {
		border-color: #2eb779;
		color: #2eb779;
	}

	.chart_box1 {
		width: 100%;
		margin-top: 20px;
		height: 360px;
	}

	#myUserChart1 {
		width: 96%;
		height: 360px;
		margin-left: 2%;
	}

	.chart_box2 {
		width: 100%;
		height: 360px;
		display: flex;
		justify-content: center;
	}

	#myUserChart2 {
		width: 500px;
		height: 360px;

	}

	.table_warp {
		width: 96%;
		margin-left: 2%;
		margin-top: 20px;
		padding-bottom: 50px;
	}

	.bottom_chart_box {
		width: 100%;
		flex: 1;
		background: #ffffff;
		border-radius: 16px;
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.bottom_chart_tit {
		width: 100%;
		height: 68px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.choose_btn_box {
		display: flex;
		align-items: center;
	}

	.choose_type {
		width: 63px;
		height: 34px;
		border: 1px solid #293787;
		font-size: 14px;
		color: #293787;
		text-align: center;
		line-height: 34px;
		cursor: pointer;
	}

	.choose_type_ac {
		background: linear-gradient(-60deg, #293787, #293787);
		box-shadow: 0px 4px 12px 0px rgba(65, 201, 98, 0.36);
		color: #ffffff;
	}

	.month_input {
		width: 120px;
		margin-left: 20px;
		margin-right: 20px;
	}

	:deep(.month_input .el-date-editor.el-input, .el-date-editor.el-input__inner) {
		width: 100% !important;
	}

	:deep(.month_input .el-input__inner) {
		height: 34px;
		line-height: 34px;
		border-color: #293787;
		color: #293787;
	}

	:deep(.month_input .el-icon-date) {
		color: #293787;
	}

	.bottom_chart {
		width: 100%;
		flex: 1;
	}

	.custTjItemRight {
		margin-right: 20px;
	}

	.custTjItemRight p {
		width: 85px;
		height: 34px;
		line-height: 34px;
		font-size: 14px;
		color: #c1c1c1;
		text-align: center;
		border: 1px solid #c1c1c1;
		cursor: pointer;
	}

	.custTjItemRight p:nth-child(1) {
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
		border-right: none;
	}

	.custTjItemRight p:nth-child(2) {
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
		border-left: none;
	}

	.custTjItemRight p.ac {
		background: #293787;
		color: #fff;
		border-color: #293787;
	}
</style>